import { createSectionModel } from '@belong/ui-sections';

// values here correspond to the content model fields
export enum GLOBAL_SECTIONS {
  GET_HELP = 'helpSection',
  GET_HELP_MOBILE = 'helpSectionMobile',
  GET_HELP_INTERNET = 'helpSectionInternet',
  FILTER = 'categoryFilterSettings'
}

export type IGlobalSections = {
  [k in GLOBAL_SECTIONS]: any;
};

const FGlobalSections = async (data: any): Promise<IGlobalSections> => {
  const sections = await Object.values(GLOBAL_SECTIONS).reduce(
    async (obj, name) => ({
      ...(await obj),
      [name]: await createSectionModel(data[name])
    }),
    Promise.resolve({})
  );
  return sections as IGlobalSections;
};

export default FGlobalSections;
